// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2XRwL","title":"AfterBackImages_title__eNACp","images":"AfterBackImages_images__3wgDJ"};